import { ExtendedQuestionnaireBlock } from '../components/compliance/ExtendedQuestionnaire';

// DORA Self-Assessment Questionnaire
export const DORA_SELF_ASSESSMENT_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'dora-ict-security',
    name_en: 'ICT Security',
    name_es: 'Seguridad TIC',
    name_ru: 'Безопасность ИКТ',
    questions: [
      {
        id: 'DORA_D3_Q1',
        blockId: 'dora-ict-security',
        text_en: 'Are critical ICT assets identified and classified?',
        text_es: '¿Se identifican y clasifican los activos TIC críticos?',
        text_ru: 'Определены и классифицированы ли критические активы ИКТ?',
        weight: 5,
      },
      {
        id: 'DORA_D3_Q2',
        blockId: 'dora-ict-security',
        text_en: 'Are vulnerability scans performed regularly?',
        text_es: '¿Se realizan análisis de vulnerabilidades regularmente?',
        text_ru: 'Проводятся ли регулярные сканирования на уязвимости?',
        weight: 4,
      },
      {
        id: 'DORA_D3_Q3',
        blockId: 'dora-ict-security',
        text_en: 'Is patch management documented and tracked?',
        text_es: '¿Se documenta y supervisa la gestión de parches?',
        text_ru: 'Документируется и контролируется ли процесс установки обновлений?',
        weight: 4,
      },
    ],
  },
  {
    id: 'dora-incident-handling',
    name_en: 'Incident Handling',
    name_es: 'Gestión de Incidentes',
    name_ru: 'Обработка инцидентов',
    questions: [
      {
        id: 'DORA_D4_Q1',
        blockId: 'dora-incident-handling',
        text_en: 'Do incident playbooks cover multi-party scenarios?',
        text_es: '¿Incluyen los manuales de incidentes escenarios multiusuario?',
        text_ru: 'Предусмотрены ли в планах реагирования сценарии с несколькими сторонами?',
        weight: 5,
      },
      {
        id: 'DORA_D4_Q2',
        blockId: 'dora-incident-handling',
        text_en: 'Are incident drills conducted with third parties?',
        text_es: '¿Se realizan simulacros de incidentes con terceros?',
        text_ru: 'Проводятся ли учения по реагированию с участием третьих сторон?',
        weight: 4,
      },
      {
        id: 'DORA_D4_Q3',
        blockId: 'dora-incident-handling',
        text_en: 'Are post-incident reviews conducted to improve processes?',
        text_es: '¿Se realizan revisiones posteriores a incidentes para mejorar los procesos?',
        text_ru: 'Проводится ли анализ инцидентов для улучшения процессов?',
        weight: 4,
      },
    ],
  },
  {
    id: 'dora-operational-resilience',
    name_en: 'Operational Resilience',
    name_es: 'Resiliencia Operacional',
    name_ru: 'Операционная устойчивость',
    questions: [
      {
        id: 'DORA_D5_Q1',
        blockId: 'dora-operational-resilience',
        text_en: 'Do impact tolerances exist for critical services?',
        text_es: '¿Existen tolerancias de impacto para servicios críticos?',
        text_ru: 'Определены ли пределы воздействия для критических услуг?',
        weight: 5,
      },
      {
        id: 'DORA_D5_Q2',
        blockId: 'dora-operational-resilience',
        text_en: 'Are alternate processing sites regularly tested?',
        text_es: '¿Se prueban regularmente los sitios de procesamiento alternativos?',
        text_ru: 'Проверяются ли регулярно альтернативные площадки обработки?',
        weight: 4,
      },
      {
        id: 'DORA_D5_Q3',
        blockId: 'dora-operational-resilience',
        text_en: 'Are backup restoration tests performed quarterly?',
        text_es: '¿Se realizan pruebas trimestrales de restauración de copias de seguridad?',
        text_ru: 'Проводятся ли ежеквартальные тесты восстановления резервных копий?',
        weight: 4,
      },
    ],
  },
  {
    id: 'dora-outsourcing',
    name_en: 'Outsourcing',
    name_es: 'Subcontratación',
    name_ru: 'Аутсорсинг',
    questions: [
      {
        id: 'DORA_D6_Q1',
        blockId: 'dora-outsourcing',
        text_en: 'Are exit strategies defined for critical third parties?',
        text_es: '¿Existen estrategias de salida definidas para terceros críticos?',
        text_ru: 'Определены ли стратегии выхода для критических поставщиков?',
        weight: 5,
      },
      {
        id: 'DORA_D6_Q2',
        blockId: 'dora-outsourcing',
        text_en: 'Are subcontracting chains assessed for resilience?',
        text_es: '¿Se evalúan las cadenas de subcontratación por su resiliencia?',
        text_ru: 'Оцениваются ли цепочки субподрядчиков на устойчивость?',
        weight: 4,
      },
      {
        id: 'DORA_D6_Q3',
        blockId: 'dora-outsourcing',
        text_en: 'Are third-party providers audited for security readiness?',
        text_es: '¿Se auditan los proveedores externos para verificar su preparación en seguridad?',
        text_ru: 'Проходят ли аудит поставщики услуг по готовности к безопасности?',
        weight: 5,
      },
    ],
  },
  {
    id: 'dora-governance',
    name_en: 'Governance',
    name_es: 'Gobernanza',
    name_ru: 'Управление',
    questions: [
      {
        id: 'DORA_D7_Q1',
        blockId: 'dora-governance',
        text_en: 'Does senior management review resilience objectives?',
        text_es: '¿Revisa la alta dirección los objetivos de resiliencia?',
        text_ru: 'Рассматривает ли руководство цели по устойчивости?',
        weight: 5,
      },
      {
        id: 'DORA_D7_Q2',
        blockId: 'dora-governance',
        text_en: 'Are board updates provided after major incidents?',
        text_es: '¿Se informa al consejo después de incidentes importantes?',
        text_ru: 'Сообщается ли совету директоров после серьёзных инцидентов?',
        weight: 4,
      },
      {
        id: 'DORA_D7_Q3',
        blockId: 'dora-governance',
        text_en: 'Does the board review digital risk reports periodically?',
        text_es: '¿Revisa el consejo los informes de riesgos digitales periódicamente?',
        text_ru: 'Рассматривает ли совет директоров отчёты по цифровым рискам?',
        weight: 4,
      },
    ],
  },
  {
    id: 'dora-testing',
    name_en: 'Testing',
    name_es: 'Pruebas',
    name_ru: 'Тестирование',
    questions: [
      {
        id: 'DORA_D8_Q1',
        blockId: 'dora-testing',
        text_en: 'Are scenario-based resilience tests integrated with business functions?',
        text_es: '¿Se integran las pruebas de resiliencia basadas en escenarios con las funciones de negocio?',
        text_ru: 'Интегрированы ли сценарные тесты устойчивости с бизнес-функциями?',
        weight: 5,
      },
      {
        id: 'DORA_D8_Q2',
        blockId: 'dora-testing',
        text_en: 'Do red team exercises cover critical external dependencies?',
        text_es: '¿Cubren los ejercicios de red team las dependencias externas críticas?',
        text_ru: 'Охватывают ли учения red team критические внешние зависимости?',
        weight: 4,
      },
      {
        id: 'DORA_D8_Q3',
        blockId: 'dora-testing',
        text_en: 'Are threat simulation exercises conducted annually?',
        text_es: '¿Se realizan ejercicios de simulación de amenazas anualmente?',
        text_ru: 'Проводятся ли ежегодные учения по моделированию угроз?',
        weight: 4,
      },
    ],
  },
];

// DORA Required Documents (ICT RM policy, Incident reporting, BCP/DR, Third-party policy)
export const DORA_DOCUMENTS_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'dora-doc-ict',
    name_en: 'ICT Risk Management',
    name_es: 'Gestión de Riesgos TIC',
    name_ru: 'Управление ИКТ-рисками',
    questions: [
      {
        id: 'dora-doc-ict-1',
        blockId: 'dora-doc-ict',
        text_en: 'ICT Risk Management Policy documented and approved?',
        text_es: '¿Política de Gestión de Riesgos TIC documentada y aprobada?',
        text_ru: 'Политика управления ИКТ-рисками документирована и утверждена?',
      },
      {
        id: 'dora-doc-ict-2',
        blockId: 'dora-doc-ict',
        text_en: 'ICT asset inventory and classification register?',
        text_es: '¿Registro de inventario y clasificación de activos TIC?',
        text_ru: 'Реестр активов ИКТ и их классификации?',
      },
    ],
  },
  {
    id: 'dora-doc-incident',
    name_en: 'Incident Reporting',
    name_es: 'Reporte de Incidentes',
    name_ru: 'Сообщение об инцидентах',
    questions: [
      {
        id: 'dora-doc-inc-1',
        blockId: 'dora-doc-incident',
        text_en: 'Incident reporting policy and procedures?',
        text_es: '¿Política y procedimientos de reporte de incidentes?',
        text_ru: 'Политика и процедуры сообщения об инцидентах?',
      },
      {
        id: 'dora-doc-inc-2',
        blockId: 'dora-doc-incident',
        text_en: 'Major incident classification and escalation criteria?',
        text_es: '¿Criterios de clasificación y escalamiento de incidentes mayores?',
        text_ru: 'Критерии классификации и эскалации крупных инцидентов?',
      },
    ],
  },
  {
    id: 'dora-doc-bcp',
    name_en: 'BCP/DR',
    name_es: 'BCP/DR',
    name_ru: 'Непрерывность и восстановление',
    questions: [
      {
        id: 'dora-doc-bcp-1',
        blockId: 'dora-doc-bcp',
        text_en: 'Business Continuity Plan documented and tested?',
        text_es: '¿Plan de Continuidad documentado y probado?',
        text_ru: 'План непрерывности документирован и протестирован?',
      },
      {
        id: 'dora-doc-bcp-2',
        blockId: 'dora-doc-bcp',
        text_en: 'Disaster Recovery Plan for critical ICT services?',
        text_es: '¿Plan de Recuperación ante Desastres para servicios TIC críticos?',
        text_ru: 'План восстановления после сбоев для критических ИКТ-услуг?',
      },
    ],
  },
  {
    id: 'dora-doc-third',
    name_en: 'Third-Party Policy',
    name_es: 'Política de Terceros',
    name_ru: 'Политика третьих сторон',
    questions: [
      {
        id: 'dora-doc-tp-1',
        blockId: 'dora-doc-third',
        text_en: 'Third-party and outsourcing risk policy?',
        text_es: '¿Política de riesgo de terceros y subcontratación?',
        text_ru: 'Политика рисков третьих сторон и аутсорсинга?',
      },
      {
        id: 'dora-doc-tp-2',
        blockId: 'dora-doc-third',
        text_en: 'Exit strategy requirements for critical ICT third parties?',
        text_es: '¿Requisitos de estrategia de salida para terceros TIC críticos?',
        text_ru: 'Требования к стратегии выхода для критических ИКТ-поставщиков?',
      },
    ],
  },
];

// DORA Required Processes (ICT risk, incident classification, TLPT, supplier monitoring)
export const DORA_PROCESSES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'dora-proc-ict-risk',
    name_en: 'ICT Risk Management Process',
    name_es: 'Proceso de Gestión de Riesgos TIC',
    name_ru: 'Процесс управления ИКТ-рисками',
    questions: [
      {
        id: 'dora-proc-ict-1',
        blockId: 'dora-proc-ict-risk',
        text_en: 'ICT risk identification and assessment process?',
        text_es: '¿Proceso de identificación y evaluación de riesgos TIC?',
        text_ru: 'Процесс выявления и оценки ИКТ-рисков?',
      },
      {
        id: 'dora-proc-ict-2',
        blockId: 'dora-proc-ict-risk',
        text_en: 'ICT risk treatment and monitoring process?',
        text_es: '¿Proceso de tratamiento y monitoreo de riesgos TIC?',
        text_ru: 'Процесс обработки и мониторинга ИКТ-рисков?',
      },
    ],
  },
  {
    id: 'dora-proc-incident',
    name_en: 'Incident Classification',
    name_es: 'Clasificación de Incidentes',
    name_ru: 'Классификация инцидентов',
    questions: [
      {
        id: 'dora-proc-inc-1',
        blockId: 'dora-proc-incident',
        text_en: 'Incident classification and severity assessment process?',
        text_es: '¿Proceso de clasificación y evaluación de severidad de incidentes?',
        text_ru: 'Процесс классификации и оценки серьёзности инцидентов?',
      },
      {
        id: 'dora-proc-inc-2',
        blockId: 'dora-proc-incident',
        text_en: 'Multi-party incident coordination process?',
        text_es: '¿Proceso de coordinación de incidentes multipartes?',
        text_ru: 'Процесс координации инцидентов с несколькими сторонами?',
      },
    ],
  },
  {
    id: 'dora-proc-tlpt',
    name_en: 'TLPT (Threat-Led Penetration Testing)',
    name_es: 'TLPT (Pruebas de Penetración Guiadas por Amenazas)',
    name_ru: 'TLPT (тестирование на проникновение по сценариям угроз)',
    questions: [
      {
        id: 'dora-proc-tlpt-1',
        blockId: 'dora-proc-tlpt',
        text_en: 'TLPT or equivalent resilience testing process?',
        text_es: '¿Proceso de TLPT o pruebas de resiliencia equivalentes?',
        text_ru: 'Процесс TLPT или эквивалентного тестирования устойчивости?',
      },
      {
        id: 'dora-proc-tlpt-2',
        blockId: 'dora-proc-tlpt',
        text_en: 'Remediation and improvement tracking for TLPT findings?',
        text_es: '¿Seguimiento de remediación y mejora para hallazgos TLPT?',
        text_ru: 'Отслеживание устранения результатов TLPT?',
      },
    ],
  },
  {
    id: 'dora-proc-supplier',
    name_en: 'Supplier Monitoring',
    name_es: 'Monitoreo de Proveedores',
    name_ru: 'Мониторинг поставщиков',
    questions: [
      {
        id: 'dora-proc-sup-1',
        blockId: 'dora-proc-supplier',
        text_en: 'Third-party ICT risk monitoring process?',
        text_es: '¿Proceso de monitoreo de riesgos TIC de terceros?',
        text_ru: 'Процесс мониторинга ИКТ-рисков третьих сторон?',
      },
      {
        id: 'dora-proc-sup-2',
        blockId: 'dora-proc-supplier',
        text_en: 'Subcontracting chain assessment process?',
        text_es: '¿Proceso de evaluación de cadenas de subcontratación?',
        text_ru: 'Процесс оценки цепочек субподрядчиков?',
      },
    ],
  },
];

// DORA Required Roles (ICT Risk Officer, Incident Manager, DORA Officer)
export const DORA_ROLES_BLOCKS: ExtendedQuestionnaireBlock[] = [
  {
    id: 'dora-roles-key',
    name_en: 'Key Roles',
    name_es: 'Roles Clave',
    name_ru: 'Ключевые роли',
    questions: [
      {
        id: 'dora-role-1',
        blockId: 'dora-roles-key',
        text_en: 'ICT Risk Officer or equivalent assigned?',
        text_es: '¿Responsable de Riesgos TIC o equivalente asignado?',
        text_ru: 'Назначен ответственный за ИКТ-риски или эквивалент?',
      },
      {
        id: 'dora-role-2',
        blockId: 'dora-roles-key',
        text_en: 'Incident Manager designated?',
        text_es: '¿Gestor de Incidentes designado?',
        text_ru: 'Назначен менеджер по инцидентам?',
      },
      {
        id: 'dora-role-3',
        blockId: 'dora-roles-key',
        text_en: 'DORA / Digital Resilience Officer role defined?',
        text_es: '¿Rol de Oficial DORA / Resiliencia Digital definido?',
        text_ru: 'Определена роль ответственного за DORA / цифровую устойчивость?',
      },
    ],
  },
];

export const DORA_QUESTIONNAIRES = {
  SELF_ASSESSMENT: DORA_SELF_ASSESSMENT_BLOCKS,
  DOCUMENTS: DORA_DOCUMENTS_BLOCKS,
  PROCESSES: DORA_PROCESSES_BLOCKS,
  ROLES: DORA_ROLES_BLOCKS,
};
